import { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext'
import type { ThemeContextValue } from '../types/theme'

/**
 * Hook d'accès au contexte de thème.
 *
 * @example
 * const { theme, toggleTheme, isDark } = useTheme()
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext)

  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }

  return context
}